<script>
import Content from '../../CHANGELOG.md';

export default {
	name: 'changelogMarkdown',
	render(createElement) {
		return createElement(Content);
	},
};
</script>
